import { useRouter } from 'next/router';

import faqUrl from '@/utils/urls/faqUrl';

import { url_faq_x_historical_data } from '@/lib/urls/faqUrls';

import Icon from '@/components/base/Icon';
import { Trans } from '@/components/tools/translation';

export const XDataAvailabilityContentBanner = () => {
    const router = useRouter();
    const locale = (router.locale as string | undefined) ?? 'en';
    const faqHref = faqUrl(url_faq_x_historical_data, locale === 'fr' ? 'fr' : undefined);

    return (
        <div
            className="dark:text-icoDarkMode-cloud flex w-full items-center gap-[6px] text-xs leading-[14px] tracking-[-0.072px] text-[#76869a]"
            data-testid="x-data-availability-banner">
            <Icon
                icon="information-circle-solid"
                className="dark:text-icoDarkMode-cloud text-xs text-icoGray-500"
            />
            <span className="font-GMedium">
                <Trans
                    i18nKey="analytics:x_data_availability_message"
                    components={{
                        tag0: (
                            <a
                                href={faqHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dark:text-icoDarkMode-cloud font-GSemiBold text-[#76869a] underline decoration-solid"
                                aria-label="Learn more about X data availability"
                            />
                        )
                    }}
                />
            </span>
        </div>
    );
};
